import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorMessage: null };

  // A fake logging service
  logErrorToServices = console.log;

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMessage: error?.toString() };
  }

  componentDidCatch(error, info) {
    this.logErrorToServices(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong: {this.state.errorMessage}</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
